export const ACCOUNT_ENDPOINTS = {
  USER_DETAILS: '/newUsers/getUserDetails',
  CHANGE_PASSWORD: '/newUsers/changePassword',
  UPDATE_LANGUAGE: '/newUsers/updateLanguage',
} as const;
